/**
 * Shared flag to signal that a logout is in progress.
 * Used by App.js to ignore the onAuthStateChanged callback that fires
 * immediately after logout() clears Redux but before Firebase signOut() settles.
 */
let loggingOut = false;

export const setLoggingOut = () => { loggingOut = true; };
export const clearLoggingOut = () => { loggingOut = false; };
export const isLoggingOut = () => loggingOut;
